import { ApolloCache, Reference } from '@apollo/client';
import { NoteBasicFragment, NoteBasicFragmentDoc } from '../../graphql/types';

export const updateCache = (
  cache: ApolloCache,
  note: NoteBasicFragment,
  memberId: string,
) => {
  cache.modify({
    id: cache.identify({ __typename: 'User', id: memberId }),
    fields: {
      notes(existingNotes = { edges: [] }) {
        const noteRef = cache.writeFragment({
          id: `Note:${note.id}`,
          fragment: NoteBasicFragmentDoc,
          data: note,
          fragmentName: 'NoteBasic',
          broadcast: true,
        });

        if (!noteRef) {
          return existingNotes;
        }

        const noteIsInList = existingNotes.edges.some(
          (edge: { node: Reference }) =>
            cache.identify(edge.node) === cache.identify(noteRef),
        );

        if (noteIsInList) {
          return existingNotes;
        }

        return {
          ...existingNotes,
          edges: [{ node: noteRef }, ...existingNotes.edges],
        };
      },
    },
  });
};
